// mui components
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledLabel = styled(Typography)(({ theme }) => ({
  ...theme.fontStyles.tiny,
  color: theme.colors.text.light.label,
}));
